<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.las1">
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:18px;font-family:Arial;">
          <span style="font-size:18px;">&nbsp;</span>
        </span>
        <b>
          <span style="font-size:18px;font-family:Arial;">L-</span>
        </b>
        <b>
          <span style="font-size:18px;font-family:宋体;">酪氨酸</span>
        </b>
      </p>
      <p>
        <span style="font-size:12px;font-family:宋体;">检验项目</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Tests</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">标准规定</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Description</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">White crystals or crystalline powder</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Identification</span>
        <span style="font-size:12px;font-family:宋体;">（</span>
        <span style="font-size:12px;font-family:Arial;">IR</span>
        <span style="font-size:12px;font-family:宋体;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">concordant with the reference</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">spectrum</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Assay</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">99.0</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">～</span>
        <span style="font-size:12px;font-family:Arial;">101.0%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">PH</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">5.0</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">～</span>
        <span style="font-size:12px;font-family:Arial;">6.5</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Specific rotation[a]D20</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">-11.3</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">°～</span>
        <span style="font-size:12px;font-family:Arial;">-12.1</span>
        <span style="font-size:12px;font-family:宋体;">°</span>
        <span style="font-size:12.0pt;font-family:Arial;"></span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">
            State of solution (Transmittance
            T430) clear &amp; colorless
          </span>
          <span style="font-size:12px;">&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≥</span>
        <span style="font-size:12px;font-family:Arial;">98.0%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Chloride(Cl)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">0.02%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Ammonium(NH4)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">0.02%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Sulfate(SO4)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">0.02%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Iron(Fe)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">10ppm</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Heavy metals(Pb)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">10ppm</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Arsenic(As)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">1ppm(As2O3)</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Other amino acids</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">conforms</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Loss on drying</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">0.20%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Residue on ignition</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">≤</span>
        <span style="font-size:12px;font-family:Arial;">0.10%</span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">
          <br>
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.las2">
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:12pt;font-family:Arial;">
          <b>
            <span style="font-size:18px;font-family:Arial;">L-</span>
            <span style="font-size:18px;font-family:宋体;">精氨酸</span>
          </b>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Description</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">White crystals or crystalline powder</span>
        </span>
      </p>
      <p>
        <span style="font-size:12px;font-family:Arial;">Identification</span>
        <span style="font-size:12px;font-family:宋体;">（</span>
        <span style="font-size:12px;font-family:Arial;">IR</span>
        <span style="font-size:12px;font-family:宋体;">）</span>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">concordant with the reference</span>
          <span style="font-size:12px;">&nbsp;</span>
          <span style="font-size:12px;">spectrum</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Assay</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">98.5</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">～</span>
        <span style="font-size:12px;font-family:Arial;">101.5%</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Specific rotation[a]D25</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">+26.3°</span>
        </span>
        <span style="font-size:12px;font-family:宋体;">～</span>
        <span style="font-size:12px;font-family:Arial;">+27.7°</span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Chloride(Cl)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">≤0.05%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Sulfate(SO4)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
          <span style="font-size:12px;">≤0.03%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Iron(Fe)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">≤30ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Heavy metals(Pb)</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">≤15ppm</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Loss on drying</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">≤0.50%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Residue on ignition</span>
          <span
            style="font-size:12px;"
          >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">≤0.30%</span>
        </span>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">
          <span style="font-size:12px;">Chromatographic purity</span>
          <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <span style="font-size:12px;">conforms</span>
        </span>
      </p>
      <span style="font-size:12.0pt;font-family:Arial;">
        <span style="font-size:12px;">Organic volatile impurities</span>
        <span style="font-size:12px;">&nbsp;&nbsp;&nbsp;</span>
        <span style="font-size:12px;">meets the requirements</span>
      </span>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <img :src="images.las3">
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:Arial;">à-</span>
          <span style="font-size:18px;font-family:宋体;">硫辛酸</span>
        </b>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        las1: require("../../../assets/img/common/las1.jpg"),
        las2: require("../../../assets/img/common/las2.jpg"),
        las3: require("../../../assets/img/common/las3.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/las.vue